<template>
	<div class="embed-geoblocking-overlay">
		<div class="embed-geoblocking-overlay__content">
			<div class="embed-geoblocking-overlay__title">
				{{ $I18n.trans('event.geoblocked.title') }}
			</div>
			<div
				class="embed-geoblocking-overlay__subtitle"
				v-html="geoblockingMessage"
			/>
		</div>
	</div>
</template>

<script>
export default {
	name:     'EmbedGeoblockingOverlay',
	computed: {
		geoblockingMessage() {
			return window.arenaConfig.geoblocking?.message ? window.$Helpers.getTranslatedContent(window.arenaConfig.geoblocking.message) : $I18n.trans('event.geoblocked.message');
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';
@import '@videotools/sass/_fonts';

.embed-geoblocking-overlay {
	position: absolute;
	top: 0;
	left: 0;
	background: var(--color-grey-900);
	width: 100%;
	height: 0;
	padding-top: 56.25%;
	z-index: 2;
}

.embed-geoblocking-overlay__title {
	@include text-lg-1($bold: true);
	margin-bottom: $sp2;

	@include size(md-up) {
		@include text-lg-3($bold: true);
	}
}

.embed-geoblocking-overlay__subtitle {
	@include text-md-1;

	&::v-deep a {
		@include text-md-1;
		color: var(--color-soft-white);
		text-decoration: underline;
	}

	@include size(md-up) {
		@include text-md-3;

		&::v-deep a {
			@include text-md-3;
		}
	}
}

.embed-geoblocking-overlay__content {
    top: 50%;
	transform: translateY(-50%);
    left: 5%;
    position: absolute;
    max-width: 95vw;

	@include size(sm-up) {
		transform: none;
		bottom: 20%;
		top: unset;
		left: 50px;
		max-width: 70%;
	}
}
</style>
